import { useState, useCallback } from 'react';

const SESSION_KEY = 'bb_session_count';
const GAME_OVER_KEY = 'bb_session_game_overs';

function getSessionCount() {
  return parseInt(localStorage.getItem(SESSION_KEY) || '0', 10);
}

export function useSession() {
  const [sessionNumber] = useState(() => {
    // If no session marker in sessionStorage, this is a new session
    if (!sessionStorage.getItem('bb_active_session')) {
      const count = getSessionCount() + 1;
      localStorage.setItem(SESSION_KEY, count.toString());
      sessionStorage.setItem('bb_active_session', '1');
      return count;
    }
    return getSessionCount();
  });

  const [gameOverCount, setGameOverCount] = useState(() => {
    return parseInt(sessionStorage.getItem(GAME_OVER_KEY) || '0', 10);
  });

  const recordGameOver = useCallback(() => {
    setGameOverCount((prev) => {
      const next = prev + 1;
      sessionStorage.setItem(GAME_OVER_KEY, next.toString());
      return next;
    });
  }, []);

  return { sessionNumber, gameOverCount, recordGameOver };
}
